<template>
    <section>
        <div :class="{'is-loading is-loading-dark': isLoading}" style="padding: 10px 0 !important;">
            <message-component v-if="showError" :status="errorStatus" :message="errorMessage"></message-component>

            <message-component :status="'generic'" :message="language.notice"></message-component>

            <div id="leagueTableContainer">
                <table
                    v-for="groupName in availableGroups"
                    width="100%" border="0" cellspacing="0" cellpadding="0"
                >
                    <thead>
                    <tr>
                        <th class="rank">&nbsp;</th>
                        <th class="club"> {{ groupName ? groupName : ''}}</th>
                        <th class="num">{{ language.P }}</th>
                        <th class="num">{{ language.W }}</th>
                        <th class="num">{{ language.D }}</th>
                        <th class="num">{{ language.L }}</th>
                        <th class="num">{{ language.GD }}</th>
                        <th class="num">{{ language.PTS }}</th>
                    </tr>
                    </thead>
                    <tbody v-for="team in groupedTeams[groupName]">
                        <tr class="club-row"
                            :class="{'club-details-open': (team.contestant_id === activeRowId || team.contestant_id === contestant_id) }"
                            v-on:click="showDetails(team.contestant_id)">
                            <td class="rank">{{ (typeof team.rank !== 'undefined') ? team.rank.rank : '-' }}</td>
                            <td class="club">{{ team.club_name }}
                                <template v-if="typeof team.rank !== 'undefined'">
                                    <img v-if="team.rank.last_rank > team.rank.rank" src="../../images/icons/move-up.svg" class="pos">
                                    <img v-if="team.rank.last_rank < team.rank.rank" src="../../images/icons/move-down.svg" class="pos">
                                </template>
                            </td>
                            <td>{{ (typeof team.rank !== 'undefined') ? team.rank.matches_played : '0' }}</td>
                            <td>{{ (typeof team.rank !== 'undefined') ? team.rank.matches_won : '0' }}</td>
                            <td>{{ (typeof team.rank !== 'undefined') ? team.rank.matches_drawn : '0' }}</td>
                            <td>{{ (typeof team.rank !== 'undefined') ? team.rank.matches_lost : '0' }}</td>
                            <td>{{ (typeof team.rank !== 'undefined') ? team.rank.goal_difference : '0' }}</td>
                            <td>{{ (typeof team.rank !== 'undefined') ? team.rank.points : '0' }}</td>
                        </tr>
                        <tr class="expandable-row" v-if="team.contestant_id === activeRowId">
                            <td colspan="8">
                                <div class="detail-wrap" :class="{'is-loading is-loading-dark is-loading-summary': isSummaryLoading}">
                                    <section v-if="activeLatestResult">
                                        <span class="section-title-sub">{{ latestResultLabel }} {{ activeLatestResult.kick_off_date }}</span>
                                        <ul class="fixtures">
                                            <fixture-component :fixture="activeLatestResult" :status="'played'"></fixture-component>
                                        </ul>
                                    </section>
                                    <section v-if="activeNextFixture">
                                        <span class="section-title-sub">{{ nextFixtureLabel }} {{ activeNextFixture.kick_off_date }}</span>
                                        <ul class="fixtures" v-if="activeNextFixture">
                                            <fixture-component :fixture="activeNextFixture" :status="'fixture'"></fixture-component>
                                        </ul>
                                    </section>
                                    <section v-if="activeForm">
                                        <span class="section-title-sub">{{ formLabel }}</span>
                                        <ul class="form clearfix">
                                            <li class="badge" v-if="typeof form.form !== 'undefined'" v-for="form in activeForm"
                                                :class="{'win' : (form.form === team.contestant_id), 'loss': (form.form !== 'draw' && form.form !== team.contestant_id), 'draw': (form.form === 'draw')}">
                                                <span v-if="form.form === team.contestant_id">{{ wonLabel }}</span>
                                                <span v-if="form.form !== team.contestant_id && form.form !== 'draw'">{{ lostLabel }}</span>
                                                <span v-if="form.form === 'draw'">{{ drawLabel }}</span>
                                            </li>
                                            <li class="more"><a :href="'/team/' + team.contestant_id">{{ clubPageLabel }}</a></li>
                                        </ul>
                                    </section>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </section>
</template>

<script>
    import axios from 'axios'
    import FixtureComponent from './FixtureComponent.vue'
    import MessageComponent from './MessageComponent.vue'
    export default {
        components: { FixtureComponent, MessageComponent },
        props: {
            contestant_id: String,
            language: {
                default: function () {
                    return {
                        P: "P",
                        W: "W",
                        D: "D",
                        L: "L",
                        GD: "GD",
                        PTS: "PTS",
                    }
                }
            },
            latestResultLabel: { type: String, default: 'Latest Result:' },
            nextFixtureLabel: { type: String, default: 'Next Fixture:' },
            formLabel: { type: String, default: 'Form' },
            clubPageLabel: { type: String, default: 'Club Page' },
            wonLabel: { type: String, default: 'W' },
            lostLabel: { type: String, default: 'L' },
            drawLabel: { type: String, default: 'D' }
        },
        data() {
            return {
                teams: null,
                activeRowId: 0,
                activeLatestResult: null,
                activeNextFixture: null,
                activeForm: null,
                showError: false,
                errorStatus: 'generic',
                errorMessage: '',
                isLoading: false,
                isSummaryLoading: false,
                groupedTeams: {},
                availableGroups: [],
            }
        },
        computed: {
        },
        mounted() {
            this.isLoading = true;
            this.$nextTick(function () {
                axios.get('/api/teams').then((response) => {
                    this.isLoading = false;
                    let teams = {};
                    let showOnlyGroup = false;
                    let contestant_id = this.contestant_id;
                    response.data.map(function (team) {
                        if (typeof team.rank === 'undefined') {
                            return;
                        }
                        let groupName = (typeof team.rank.group_name === 'undefined' ? '' : team.rank.group_name);

                        if (typeof teams[groupName] === 'undefined') {
                            teams[groupName] = [];
                        }
                        teams[groupName].push(team);

                        // if we've got a contestant_id, let's show just that contestant's group
                        if (typeof contestant_id !== 'undefined') {
                            if (contestant_id === team.contestant_id) {
                                showOnlyGroup = groupName;
                            }
                        }
                    });

                    this.groupedTeams = teams;
                    if (showOnlyGroup) {
                        this.availableGroups = [showOnlyGroup];
                    } else {
                        this.availableGroups = Object.keys(teams).sort();
                    }

                    if (this.availableGroups.length === 0) {
                        this.errorStatus = 'generic';
                        this.errorMessage = this.language.error_no_teams;
                        this.showError = true;
                    }
                }).catch((e) => {
                    this.isLoading = false;
                    this.errorStatus = 'error';
                    this.errorMessage = 'Unable to get table data. Please try again later';
                    this.showError = true;
                });
            });
        },
        methods: {
            showDetails (id) {
                if (this.activeRowId === id) {
                    this.activeRowId = 0;
                    return;
                }
                this.activeLatestResult = null;
                this.activeNextFixture = null;
                this.activeForm = null;
                this.activeRowId = id;
                this.isSummaryLoading = true;
                axios.get('/api/teams/' + id + '/short-summary').then((response) => {
                    this.activeLatestResult = response.data.latestResult;
                    this.activeNextFixture = response.data.nextFixture;
                    this.activeForm = response.data.form;
                    this.isSummaryLoading = false;
                }).catch(() => {
                    this.isSummaryLoading = false;
                    this.errorStatus = 'error';
                    this.errorMessage = 'Unable to get summary data. Please try again later';
                    this.showError = true;
                });
            },
        }
    }
</script>
